import { Observable } from 'rxjs';
import { IdType, User, UserRequest, UserShare } from './model';

export abstract class UserRepository {
  abstract create(user: UserRequest): Observable<User>;
  
  abstract passwordRecovery(data: any): Observable<void>;
  
  abstract update(uid: string, cid: string | null, payload: any): Observable<User>;
  abstract get(uid: string, cid: string | null): Observable<User>;
  abstract getSharedProfiles(uid: string, cid: string | null): Observable<UserShare[]>;
  abstract listIdTypes(uid: string, cid: string | null): Observable<IdType[]>;
  abstract roleVerify(uid: string, cid: string | null): Observable<any>;
  abstract uploadAvatar(uid: string, cid: string | null, file: File): Observable<any>;
  abstract updatePassword(uid: string, cid: string | null, password: string): Observable<any>;
}
